import { BaseDrawOption } from '@/modules/ta/widget/models/drawoptions/BaseDrawOption';

export class MediaWidgetDrawOption extends BaseDrawOption {}
